import { TextSelection } from 'prosemirror-state'

export function validateCustomListNumbers(tr, listableNodeTypes = []) {
  const { anchor, head } = tr.selection
  const commands = generateCustomListCorrectionMarkup(tr.doc, listableNodeTypes)
  let changed = false
  const sortedPos = Array.from(commands.keys()).sort((a, b) => a - b)
  for (const pos of sortedPos) {
    const attrs = commands.get(pos)
    if (attrs) {
      tr.setNodeMarkup(pos, undefined, attrs)
      changed = true
    }
  }
  if (changed) {
    tr.setSelection(TextSelection.create(tr.doc, anchor, head))
  }
  return changed ? tr : null
}

export function generateCustomListCorrectionMarkup(
  doc,
  listableNodeTypes = [],
  commands = new Map(),
) {
  const listNodeStacks = new Map()

  let atListDepth = -1
  doc.descendants((child, pos) => {
    const attrs = {
      ...child.attrs,
      ...(commands.get(pos) || {}),
    }
    if (child.type.name === 'customListItem') {
      const listId = attrs['list-id'] || null
      if (!listNodeStacks.has(listId)) {
        listNodeStacks.set(listId, [])
      }
      const listStack = listNodeStacks.get(listId)
      const depth = attrs.depth
      const itemNo = attrs['item-number']
      while (listStack.length < depth) {
        listStack.push(0)
      }
      if (listStack.length < depth + 1) {
        listStack.push(-1)
      }
      while (listStack.length > depth + 1) {
        listStack.pop()
      }
      listStack[depth]++
      const expectedItemNo = listStack[depth]
      if (itemNo !== expectedItemNo) {
        // Get the position of the list item
        // We need to update the item number
        commands.set(pos, {
          ...attrs,
          'item-number': expectedItemNo,
        })
      }
      atListDepth = depth
    } else if (child.type.name === 'noteBoardNote') {
      // If we encounter a listable node type, it needs its depth to be ensured
      // if the listStack is not empty
      if (attrs['list-depth'] !== atListDepth) {
        commands.set(pos, {
          ...attrs,
          'list-depth': atListDepth,
        })
      }
    } else {
      // Reset the list depth if we encounter a non-listable node type
      atListDepth = -1
    }
    return false
  })

  // let listStack = [
  //   {
  //     depth: 0,
  //     itemNo: -1,
  //   },
  // ]
  //
  // doc.descendants((child, pos) => {
  //   const attrs = {
  //     ...child.attrs,
  //     ...(commands.get(pos) || {}),
  //   }
  //   if (child.type.name === 'customListItem') {
  //     const depth = attrs.depth
  //     const listId = attrs['list-id']
  //     const itemNo = attrs['item-number']
  //
  //     while (
  //       listStack.length > 0 &&
  //       listStack[listStack.length - 1].depth > depth
  //     ) {
  //       listStack.pop()
  //     }
  //     let lastItem = listStack[listStack.length - 1]
  //     if (lastItem.depth < depth) {
  //       listStack.push({
  //         depth: depth,
  //         itemNo: -1,
  //       })
  //       lastItem = listStack[listStack.length - 1]
  //     }
  //     const expectedItemNo = lastItem.itemNo + 1
  //     if (itemNo !== expectedItemNo) {
  //       // Get the position of the list item
  //       // We need to update the item number
  //       commands.set(pos, {
  //         ...attrs,
  //         'item-number': expectedItemNo,
  //       })
  //     }
  //     lastItem.itemNo = expectedItemNo
  //   } else {
  //     if (listableNodeTypes.includes(child.type.name)) {
  //       // If we encounter a listable node type, it needs its depth to be ensured
  //       // if the listStack is not empty
  //       const expectedDepth =
  //         listStack[listStack.length - 1].itemNo === -1
  //           ? -1
  //           : listStack[listStack.length - 1].depth
  //       if (attrs['list-depth'] !== expectedDepth) {
  //         commands.set(pos, {
  //           ...attrs,
  //           'list-depth': expectedDepth,
  //         })
  //       } // Otherwise, we don't need to do anything
  //     } else {
  //       listStack = [
  //         {
  //           depth: 0,
  //           itemNo: -1,
  //         },
  //       ]
  //     }
  //   }
  //   return false
  // })

  return commands
}
